import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { isEmpty } from "lodash"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import { v4 as uuidv4 } from 'uuid'
import {
  Button,
  Card,
  CardBody,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  Container,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap"

import FullCalendar from "@fullcalendar/react"
import dayGridPlugin from "@fullcalendar/daygrid"
import interactionPlugin, { Draggable } from "@fullcalendar/interaction"
import BootstrapTheme from "@fullcalendar/bootstrap"
import listPlugin from '@fullcalendar/list'
import adaptivePlugin from '@fullcalendar/adaptive'

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import {
  addNewEvent,
  deleteEvent,
    deleteMonthEvents,
  getEvents,
  updateEvent,
  updateProfile
} from "../../store/calendar/actions"
import { getProfile } from "../../store/auth/profile/actions"
import DeleteModal from "./DeleteModal"
//css
import "@fullcalendar/bootstrap/main.css"
const Calender = props => {
  const { events, user, history, onDeleteMonthEvents,onGetEvents, onGetProfile  } = props
  const [modal, setModal] = useState(false)
    const [welcomeModal, setWelcomeModal] = useState(false)
  const [deleteModal, setDeleteModal] = useState(false)
  const [category, setCategory] = useState(false)
  const [description, setDescription] = useState()
  const [event, setEvent] = useState({})
  const [eventId, setEventId] = useState()
  const [title, setTitle] = useState()
  const [isMultiDay, setIsMultiDay] = useState({})
  const [startDay, setStartDay] = useState(0)
  const [endDay, setEndDay] = useState(0)
  const [isEdit, setIsEdit] = useState(false)
  const [notification, setNotifications] = useState(false)
  const [daysNotification, setDaysNotification] = useState(1)
  const [contactEmail, setContactEmail] = useState()
  const [contactPhone, setContactPhone] = useState()
  const [showInstructions, setShowInstructions] = useState(true)
  const calendarRef = React.createRef()
  const username = JSON.parse(localStorage.getItem("user")).user;
  useEffect(() => {
    onGetEvents()
    onGetProfile(username)
    new Draggable(document.getElementById("external-events"), {
      itemSelector: ".external-event",
    })
  }, [])

    useEffect(() => {
        if (events.length>0)
            setWelcomeModal(false)
        else
            setWelcomeModal(true)
    }, [events])

  useEffect(() => {
    if (!modal && !isEmpty(event) && !!isEdit) {
      setTimeout(() => {
        setEvent({})
        setIsEdit(false)
      }, 500)
    }
    if (user.settings) {
       if (user.settings.calendar.notifications) {
	   setNotifications(true);
       }
       if (user.settings.calendar.contactInfo.email) {
	   setContactEmail(user.settings.calendar.contactInfo.email)
       } else {
	   setContactEmail(user.email)
       }
       if (user.settings.calendar.contactInfo.phone) {
           setContactPhone(user.settings.calendar.contactInfo.phone)
       }
       if (user.settings.calendar.daysNotification) {
           setDaysNotification(user.settings.calendar.daysNotification)
       }
    }
  }, [modal, event, user])

  /**
   * Handling the modal state
   */
  const toggle = () => {
    setModal(!modal)
  }

  const close = () => {
    setIsEdit(false)
    toggle() 
  }

  const changeStartDate = (arg) => {
    setStartDay(arg)
  }

  const changeEndDate = (arg) => {
    setEndDay(arg)
  }


  const saveCalendarSettings = () => {
    const { onUpdateProfile } = props
    user.settings.calendar.contactInfo.email = contactEmail;
    user.settings.calendar.contactInfo.phone = contactPhone;
    user.settings.calendar.daysNotification = daysNotification;
    onUpdateProfile(user);
  }

  const updateNotifications = () => { 
    const { onUpdateProfile } = props
    user.settings.calendar.notifications = !notification;
    setNotifications(!notification)
    onUpdateProfile(user)
  }

  /**
   * Handling date click on calendar
   */
  const handleDateClick = arg => {
    if (arg && arg.date)
        setStartDay(arg.date)
    else
	setStartDay(new Date())
    setIsMultiDay(false)
    toggle()
  }

  const handleMultiSelect = arg => { 
    if ((arg.end.getDay()-arg.start.getDay())<2)
        return;
    setStartDay(arg.start)
    setEndDay(arg.end)
    setIsMultiDay(true)
    toggle()
  }

  /**
   * Handling click on event on calendar
   */
  const handleEventClick = arg => {
	  console.log("DFASDF");
    const event = arg.event
    setTitle(event.title)
    setCategory(event.extendedProps.category)
    setEventId(event.id)
    setDescription(event.extendedProps.description)
    setStartDay(event.start)
    setEndDay(event.end)
    if (event.end) {
        setIsMultiDay(true)
    } else {
        setIsMultiDay(false)	
    }
    setIsEdit(true)
    toggle()
  }

  /**
   * Handling submit event on event form
   */
  const handleValidEventSubmit = () => {
    const { onAddNewEvent, onUpdateEvent } = props
    if (isEdit) {
      const updateEvent = {
        id: eventId,
        title: title,
        start: startDay,
	end: endDay,
        description: "",
	category: category
      }
	    console.log(updateEvent);
	 var editEvent = calendarRef.current.getApi().getEventById(eventId)
      // update event
      onUpdateEvent(updateEvent)
    } else {
      const user = JSON.parse(localStorage.getItem("user")).user
      const newevent = {
        id: uuidv4(),
	username: user,
        title: title,
	description: "",
	plant: "Carrots",
        start: startDay,
	category: category,
      }
      if (endDay) 
        newevent["end"] = endDay
      // save new event
      onAddNewEvent(newevent)
    }
    //setStartDay(null)
    toggle()
  }

    async function clearMonthEvents() {
        const calendarApi = calendarRef.current.getApi();
        const currentStartDate = calendarApi.view.currentStart;
        const currentMonth = currentStartDate.getFullYear() + '-' +
            String(currentStartDate.getMonth() + 1).padStart(2, '0');

        const events = {
            month: currentMonth,
            username: username
        };
        console.log("Clearing month events", events);
        try {
            // Wait for delete operation to complete
            await onDeleteMonthEvents(events);

            // Then refetch events
            await onGetEvents();
        } catch (error) {
            console.error("Error clearing month events:", error);
            // Optionally show an error message to the user here
        }
    }


  const getColor = category => {
     if (category=="Seed Starting") {
	 return "green";
     } else if (category=="Harvest") {
	 return "orange";
     } else if (category=="Transplanting") {
	 return "blue";
     }
  }   

  /**
   * On delete event
   */
  const handleDeleteEvent = () => {
    const { onDeleteEvent } = props
    onDeleteEvent(eventId)
    var delEvent = calendarRef.current.getApi().getEventById(eventId)
    if (delEvent)
	delEvent.remove()
    setDeleteModal(false)
    toggle()
  }

  const printCalendar = () => {
    window.print() 
  }

  function hideInstructions() {
     var foo = !showInstructions
     setShowInstructions (foo)
  }


  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteEvent}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <Container fluid={true}>
          {/* Render Breadcrumb */}
          <Row>
            <Col lg={12}>
	       <div id="external-events" className="mt-3">
                       <Button type="text" color="primary" onClick={() => {hideInstructions()}}>
	  { showInstructions ? <i class="mdi mdi-arrow-collapse-left"></i> : <i class="mdi mdi-arrow-collapse-right"></i>  } 
                                          </Button>
                </div>

              <Card>
                <CardBody>
                  <Row>
	            {showInstructions && <Col lg={3}>

                      <div className="mt-5 d-xl-block">
                        <h5 className="text-center">Add An Event
                                          </h5>

                        <ul className="pl-3">
                          <li className="text-muted mb-3">
                            To add a new Garden Event, left-click on the target date or drag with your mouse from your start to end date. A dialog will pop up with fields for additional information about your event.
                            here.
                          </li>
                        </ul>

	               <h5>Notification Settings</h5>
	                 <ul className="pl-3">
                          <li className="text-muted mb-3">
                            You can choose to receive email or text alerts for your upcoming planting dates.  This helps you remember if you've planned your growing season ahead of time but would like reminders to keep you on track.
	                  </li>
	                 </ul>
	                <div
                          className="custom-control custom-switch mb-2"
                          dir="ltr"
                        >
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="customSwitch1"
	                    checked={notification}
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="customSwitch1"
                            onClick={e => {
		              updateNotifications()
                            }}
                          >
                           Enable Calendar Notifications 
                          </label>
                        </div>

	               {notification && <div>
			 <FormGroup>
                             <Label
                                for="contact_email"
                                     >
                                    Email Address For Receiving Email Notifications</Label>
                                    <Input type="text" name="contact_email" value={contactEmail}
                                        onChange={e => setContactEmail(e.target.value)} placeholder="" />
                               </FormGroup>

			   <FormGroup>
                             <Label
                                for="contactPhone"
                                     >
			       Phone Number For Receiving Text Notifications
                                    </Label>
                                    <Input type="text" name="contactPhone" value={contactPhone}
                                        onChange={e => setContactPhone(e.target.value)} placeholder="" />
                               </FormGroup>

                         <FormGroup>
                             <Label
                                for="daysNotification"
                                     >
                                        Number of Days Before Event To Be Notified
                                    </Label>
                                    <Input type="text" name="daysNotification" value={daysNotification}
                                        onChange={e => setDaysNotification(e.target.value)} placeholder="" />
                               </FormGroup>

			        <Button type="text" color="warning"  onClick={() => {saveCalendarSettings()}}>
                                                  Update Settings
                                          </Button>
 <Button type="text" color="warning"  onClick={() => {clearMonthEvents()}}>
                                                  Clear Month Events
                                          </Button>

</div>



		       } 

	             
                      </div>
                    </Col>
		    }
                    <Col md={showInstructions ? 9:12}>
                      {/* fullcalendar control */}
                      <FullCalendar
                        ref={calendarRef}
	                plugins={[
                          BootstrapTheme,
                          dayGridPlugin,
			  listPlugin,
                          interactionPlugin,
                        ]}
                        slotDuration={"00:15:00"}
                        themeSystem="bootstrap"
	                customButtons= {{
                            custom1: {
                               text: 'Print',
                               click: function() {
                                   window.print();
                               },
                            },
                        }}
                        headerToolbar={{
                          left: "prev,next custom1",
                          center: "title",
                          right: "dayGridMonth,dayGridWeek,listMonth"
                        }}
                        events={events}
	                displayEventTime={false}
                        editable={true}
                        selectable={true}
                        dateClick={handleDateClick}
                        eventClick={handleEventClick}
	                select={handleMultiSelect}
	                draggable={false}
                      />

                      {/* New/Edit event modal */}
                      <Modal isOpen={modal} className={props.className}>
                        <ModalHeader toggle={toggle} tag="h4">
                          {!!isEdit ? "Edit Event" : "Add Event"}
                        </ModalHeader>
                        <ModalBody>
                          <Form>
	                       <FormGroup>
	                            <Label
	                                  for="titleInput"
	                             >
	                                Title 
	                            </Label>
	                            <Input type="text" name="titleInput" value={title} 
	                                onChange={e => setTitle(e.target.value)} placeholder="Enter Event Title" />
	                       </FormGroup>
	                       <FormGroup>
	                             <Label
	                                    for="categoryInput"
	                             >
	                                  Category
	                             </Label>
	                             <Input type="select" value={category} onChange={e => setCategory(e.target.value)}>
	                                 <option value=""></option>
	                                 <option value="Harvest">Harvest</option>
	                                 <option value="Transplanting">Transplanting</option>
	                                 <option value="Maintenance">Maintenance</option>
	                                 <option value="Seed Starting">Seed Starting</option>
	                                 <option value="Construction">Construction</option>
	                              </Input>
	                       </FormGroup>
	                       <FormGroup>
	                          <Label
	                                for="startDayInput"
	                          >
	                             Start Date
	                          </Label>
	  <DatePicker
	                                              className="form-control"
	                                              selected={startDay}
	                                              onChange={changeStartDate}
	                                            />
	                       </FormGroup>
                                <FormGroup>
	                               <Label
	                                      for="endDayInput"
	                               >
	                                      End Date
	                               </Label>
	                               <DatePicker
	                                     className="form-control"
	                                     selected={endDay}
	                                     onChange={changeEndDate}
	                               />
	                      </FormGroup>
				
                            <Row>
                              <Col>
                                <div className="text-right">
                                  <button
                                    type="button"
                                    className="btn btn-light mr-2"
                                    onClick={close}
                                  >
                                    Close
                                  </button>
                                  {!!isEdit && (
                                    <button
                                      type="button"
                                      className="btn btn-danger mr-2"
                                      onClick={() => setDeleteModal(true)}
                                    >
                                      Delete
                                    </button>
				  )}
                                  <button
                                    type="button"
                                    className="btn btn-success save-event"
	                            onClick={() => handleValidEventSubmit()}
                                  >
                                    Save
                                  </button>
                                </div>
                              </Col>
                            </Row>
                          </Form>
                        </ModalBody>
                      </Modal>

                        <Modal isOpen={welcomeModal}  toggle={() => {
                            setWelcomeModal(false)
                        }} size="lg" centered>
                            <ModalHeader  toggle={() => {
                                setWelcomeModal(false)
                            }}>
                                Welcome to Calendar!
                            </ModalHeader>
                            <ModalBody>
                                <Row>
                                    {/* Left Column: Explanatory Text */}
                                    <Col md={6}>
                                        <h5>Events and To Do Management</h5>
                                        <p>
                                            Calendar is a straightforward calendar feature for managing all your upcoming garden
                                            tasks, planting dates, and events.  It is integrated with the other parts of SAGE so seed starting
                                            dates, transplant dates and harvest dates will automatically be created here.  You can also
                                            set up your notifications to get alerts sent by email or text to remind you.  There is a bit more information
                                            about how to set that up in the video to the right.
                                        </p>
                                    </Col>

                                    {/* Right Column: Video */}
                                    <Col md={6}>
                                        <div className="embed-responsive embed-responsive-16by9">
                                            <iframe
                                                className="embed-responsive-item"
                                                src="https://www.youtube.com/embed/9J44QTJ_1vQ?si=bDiwONOMdOV2ZuXL"
                                                title="Welcome Video"
                                                allowFullScreen
                                            ></iframe>
                                        </div>
                                    </Col>
                                </Row>
                            </ModalBody>
                            <div className="d-flex justify-content-end p-3">
                                <Button color="primary" onClick={() => {
                                    setWelcomeModal(false)
                                }}>
                                    Get Started
                                </Button>
                            </div>
                        </Modal>

                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

Calender.propTypes = {
  events: PropTypes.array,
  className: PropTypes.string,
  onGetEvents: PropTypes.func,
  onGetProfile: PropTypes.func,
  onAddNewEvent: PropTypes.func,
  onUpdateEvent: PropTypes.func,
  onUpdateProfile: PropTypes.func,
  onDeleteEvent: PropTypes.func,
}

const mapStateToProps = (state) => {
  var modEvents = state.calendar.events;
  for (var i=0; i<modEvents.length; i++) {
      var event = modEvents[i];
      if (event.category=="Seed Starting") {
	  event.className = "bg-success text-white";
	  event.color = "#34c38f";
      } else if (event.category=="Harvest") {
          event.className = "bg-danger text-white";
          event.color = "#f46a6a";
      } else if (event.category=="Transplanting") {
	  event.className = "bg-warning text-white";
	  event.color = "#f1b44c";
      } else if (event.category=="Construction") {
          event.className = "bg-info text-white";
	  event.color = "#50a5f1";
      } else if (event.category=="Maintenance") {
          event.className = "bg-secondary text-white";
	  event.color = "#050505";
      }
  }
  return ({
  events: modEvents,
  user: state.Profile.user})
}

const mapDispatchToProps = dispatch => ({
  onGetEvents: () => dispatch(getEvents()),
  onGetProfile: (username) => dispatch (getProfile(username)),
  onAddNewEvent: event => dispatch(addNewEvent(event)),
  onUpdateEvent: event => dispatch(updateEvent(event)),
  onUpdateProfile: user => dispatch(updateProfile(user)),
  onDeleteEvent: event => dispatch(deleteEvent(event)),
    onDeleteMonthEvents: events => dispatch(deleteMonthEvents(events)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Calender)
